import * as React from 'react';
import { useQuery } from '@grandvisionhq/graphql';
import { GET_TOPIC_LIST } from '../operations/queries/get-topic-list.js';

const useTopicList = ()=>{
    const { data  } = useQuery(GET_TOPIC_LIST);
    const [topicList, setTopicList] = React.useState({});
    React.useEffect(()=>{
        if (data === null || data === void 0 ? void 0 : data.getTopicList) {
            const list1 = data.getTopicList.reduce((list, topic)=>{
                if (!topic) {
                    return list;
                }
                list[topic.label] = topic;
                return list;
            }, {});
            setTopicList(list1);
        }
    }, [
        data
    ]);
    return topicList;
};

export { useTopicList };
//# sourceMappingURL=hooks.js.map
